import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

export const bodyStyle = style({
  // this style needs to be kept
});

export const alignStyle = recipe({
  variants: {
    align: {
      center: {
        textAlign: "center",
      },
      right: {
        textAlign: "right",
      },
      left: {
        textAlign: "left",
      },
    },
  },
  defaultVariants: {
    align: "left",
  },
});
